<nav class="navbar navbar-expand-lg navbar-light bg-light txt">
  <a class="navbar-brand" routerLinkActive="active" [routerLink]="['/communities']">
    <img [src]="logoCommunity" class="logo-kastor float-left" alt="Kastor" height="30">
  </a>
  <ng-container>
    <div>
      <label (click)="toggleClass()" class="pt10"><i class="fal fa-bars"></i></label>
    </div>
    <div class="float-left d-none d-lg-block ml20">{{administrationName}}</div>
  </ng-container>
  <ul class="navbar-nav mr-auto">

  </ul>
<!-- Notification Widget  -->
  <div class="appPublicationContainer">
    <app-publications *ngIf="showPublications"></app-publications>
  </div>
  
  <ng-container class="form-inline my-2 my-lg-0">
    <div class="float-left d-none d-lg-block mr10">
      <div *ngIf="showSearch" class="input-group">
        <input type="text" [(ngModel)]="query"
          class="form-control form-control-sm not-border dropdown-toggle box-primary-primary-lighter-1 hisearch"
          placeholder="{{'GENERAL.SEARCH' | translate}}" aria-describedby="basic-addon1">
        <div class="input-group-append">
          <span class="input-group-text mt1 mb1 not-border box-primary-primary-lighter-1 hisearchs" id="basic-addon1">
            <i class="fal fa-search"></i>
          </span>
        </div>
      </div>
      <div *ngIf="query.length > 2" class="dropdown-menu-ida m0 custom-user pt">
        <div class="triangle"></div>
        <a *ngFor="let item of search | menuFilter:['text', 'textTags']:queryTrim()" routerLinkActive="active"
          [routerLink]="item.link" (click)="clickLink();" class="dropdown-item">{{item.name | translate}}
          <ng-container *ngIf="item.tags">
            <small><span
                *ngFor="let tag of item.tags; let i=index;"><i>{{ tag | translate }}{{item.tags.length > 1 ? i < (item.tags.length - 1) ? ', ' : '' : ''}}</i></span></small>
          </ng-container>
          <i class="fal fa-angle-right float-right mt5 mr-10"></i>
        </a>
        <a *ngIf="((search | menuFilter:['text', 'textTags']:queryTrim()).length === 0)" class="dropdown-item">{{'GENERAL.WITHOUT_RESULTS'
          | translate}}</a>
      </div>
    </div>
    <img [src]="imgUser" class="d-none d-lg-block img-user-toolbar" alt="User" height="30">
    <img (click)="menuXs = !menuXs" [src]="imgUser" class="d-lg-none img-user-toolbar" alt="User" height="30">
    <div class="float-left ml10 d-none d-lg-block">
      <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{userInSession}} <i
          class="fal fa-angle-down mt5 ml5"></i></span>
      <div class="dropdown-menu dropdown-menu-ida m0 custom-user" aria-labelledby="dropdownMenuButton">
        <div class="triangle"></div>

        <a class="dropdown-item pointer"
          (click)="returnSelectCommunity();">{{'ADMINISTRATION.GENERAL.SINGULAR' | translate}}</a>
        <a class="dropdown-item" [routerLink]="['/profile']" href="#">{{'GENERAL.MY_PROFILE' | translate}}</a>
        <a class="dropdown-item" (click)="clear();" href="#">{{'GENERAL.SIGN_OFF' | translate}}</a>
      </div>
    </div>
  </ng-container>

</nav>

<!--alert-notification-->
  <div class="notification-alert-k notification-bg-color-error" [ngClass]="{'active-notification': debtStatus && debtStatus === 'DISABLE' && hideDebtStatus === false}">
    <span class="text-notification-bar">
        <i class="fa fa-exclamation-circle"></i>
        {{'GENERAL.NOTIFICATION.DEBT_NOTIFICATION' | translate }}
    </span>

    <!--close-->
    <button class="close-btn-alert" title="Cerrar" (click)="closeDebtStatus()">
      <img src="assets/img/close-notification.svg">
    </button>
    <!--close-->
  </div>
<!--alert-notification-->

<ul *ngIf="menuXs" class="menu-desplegable animated fadeIn d-lg-none">
  <li class="li-menu-xs pointer" (click)="returnSelectCommunity(); menuXs = false;"><i class="fal fa-user-lock mr10 svg-width"></i>{{'ADMINISTRATION.GENERAL.SINGULAR' | translate}}</li>
  <li class="li-menu-xs pointer" [routerLink]="['/profile']">
    <i class="fal fa-user-lock mr10 svg-width"></i>{{'GENERAL.MY_PROFILE' | translate}}
  </li>
  <li class="li-menu-xs pointer" [routerLink]="['/auth']" (click)="clear(); menuXs = false;"><i class="fal fa-sign-out-alt mr10 svg-width"></i>{{'GENERAL.SIGN_OFF' | translate}}</li>
</ul>
<div *ngIf="menuXs" class="overlay-menu-xs d-lg-none"></div>



// WEBPACK FOOTER //
// ./src/app/layout/toolbar/toolbar.component.html